export const host = process.env.REACT_APP_API_HOST;
export const apiurl = process.env.REACT_APP_API_URL;
export const clientSecret = process.env.REACT_APP_CLIENT_SECRET;
export const clientId = process.env.REACT_APP_CLIENT_ID;
export const token = process.env.REACT_APP_TOKEN;